export const selectDocumentReferrer = state => state.analytics.referrer
export const selectRedirectUrl = state => state.analytics.redirectUrlAfterLogin
export const selectTrackedExperiments = state => state.analytics.trackedExperiments
